import { render } from "./VsudSelect.vue?vue&type=template&id=a10a7006&scoped=true"
import script from "./VsudSelect.vue?vue&type=script&lang=js"
export * from "./VsudSelect.vue?vue&type=script&lang=js"

import "./VsudSelect.vue?vue&type=style&index=0&id=a10a7006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10a7006"]])

export default __exports__